import React from "react";

function Terms() {
  return (
    <div style={{ maxWidth: "800px", margin: "40px auto", padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Terms of Service for Blickfast</h1>
      <p>Last Updated: April 22, 2025</p>
      
      <p>Welcome to <strong>Blickfast</strong>, a productivity tool designed to assist busy content creators and social media managers in managing and automating their TikTok content from their laptop.</p>
      
      <h2>1. Use of the App</h2>
      <p>By using Blickfast, you agree to:</p>
      <ul>
        <li>Be an authorized user with access provided by the app administrators.</li>
        <li>Use the app in compliance with TikTok's Terms of Service and Community Guidelines.</li>
        <li>Refrain from any misuse or unauthorized access of TikTok's API or services.</li>
      </ul>
      
      <h2>2. Data Handling</h2>
      <p>Blickfast accesses TikTok data solely for the purpose of content management and analytics. We do not collect or share personal data from TikTok users. Any data accessed via the TikTok API is used only for the functionalities provided by the app and is not stored beyond what is necessary.</p>
      
      <h2>3. Changes to Terms</h2>
      <p>We may update these Terms from time to time. If we do, we'll update the "Last updated" date above.</p>
      
      <h2>4. Contact</h2>
      <p>For questions or support regarding Blickfast, please contact us at: <strong>founders@naturalui.com</strong></p>
    </div>
  );
}

export default Terms; 